/*
 * Popups for the footer
 */
class RLM_Popup {
    constructor (wrapper) {
        this.mainWrapper = jQuery(wrapper);

        if (!this.mainWrapper.find('.js-popup').length) {
            return;
        }
           
        this.initState();
        this.initEvents();
        this.createCache();
    }

    initState () {
        this.win = jQuery(window);
        this.popup = jQuery('#dynamic-popup-content');
        this.popupContentWrapper = this.popup.find('.dynamic-popup-content-inner');
        this.links = this.mainWrapper.find('.js-popup > a');
        this.closeButton = this.popup.find('.dynamic-popup-content-close');
        this.cache = [];
    }

    initEvents () {
        this.links.each((i, link) => {
            jQuery(link).on('click', e => {
                e.preventDefault();
                let url = jQuery(link).attr('href');
                
                if (this.cache[url]) {
                    this.showPopup(this.cache[url]);
                } else {
                    jQuery.ajax(url).done((res) => {
                        this.showPopup(res);
                    });
                }
            });
        });

        jQuery(document).ready(() => {
            let cookieBannerLink = jQuery('#catapult-cookie-bar .ctcc-more-info-link');

            if (cookieBannerLink.length && !cookieBannerLink.hasClass('is-activated')) {
                cookieBannerLink.addClass('is-activated');
                
                cookieBannerLink.on('click', e => {
                    e.preventDefault();
                    let url = jQuery(cookieBannerLink).attr('href');
                    
                    if (this.cache[url]) {
                        this.showPopup(this.cache[url]);
                    } else {
                        jQuery.ajax(url).done((res) => {
                            this.showPopup(res);
                        });
                    }
                });
            }
        });

        this.closeButton.on('click', e => {
            e.preventDefault();
            this.closePopup();
        });
    }

    createCache () {
        this.cache = [];

        this.links.each((i, link) => {
            let url = jQuery(link).attr('href');

            jQuery.ajax(url).done((res) => {
                this.cache[url] = res;
            });
        });
    }

    showPopup (content) {
        jQuery(document.body).addClass('no-scroll');
        let output = jQuery('<div>' + content + '</div>').find('.site-main').html();
        this.popupContentWrapper.empty().html(output);
        this.popupContentWrapper.scrollTop(0);
        this.popup.removeClass('is-hidden');
    }

    closePopup () {
        jQuery(document.body).removeClass('no-scroll');
        this.popup.addClass('is-hidden');
    }
}

new RLM_Popup(document.body);